import type { LanguageCode } from '../types'
import type { TranslationStructure } from '../services/translations'
import en from './en'

const cache = new Map<LanguageCode, TranslationStructure>([['en', en]])

export function readPreferredLanguage(fallback: LanguageCode = 'en'): LanguageCode {
    try {
        const saved = localStorage.getItem('dhtn-lang')
        if (saved === 'en' || saved === 'ha' || saved === 'ar') return saved
        if (saved !== null) localStorage.removeItem('dhtn-lang')
    } catch { /* Use the supplied language when browser storage is unavailable. */ }
    return fallback
}

export const cachedLanguage = (language: LanguageCode) => cache.get(language)

export async function loadLanguage(language: LanguageCode): Promise<TranslationStructure> {
    const cached = cache.get(language)
    if (cached) return cached
    const strings = language === 'ar' ? (await import('./ar')).default : (await import('./ha')).default
    cache.set(language, strings)
    return strings
}
